import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router';
import MapComponent from '../MapComponent';
import useApi from '../../api/useApi';
// import Notification from '../../components/Notification';
import Notification from '../Notification';
import '../../scrollbar.css';

function Traceability({ deviceId, assetId, handleClose }) {
  const history = useHistory();
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [{ isLoading, isError, data }, getTraceData] = useApi();
  const [traceData, setTraceData] = useState();
  const [coordinates, setCoordinates] = useState([]);
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState();
  const [message, setMessage] = useState();

  useEffect(() => {
    let _device = deviceId;
    getTraceData(`/device/${_device}/traceData`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      const coor = data?.data?.map((x, key) => {
        return {
          lat: parseFloat(x.lat),
          lng: parseFloat(x.lng),
        };
      });
      setCoordinates(() => coor);
      data.location = data.location;
      setTraceData(data);
    }
    if (isError) {
      setType('Error');
      setMessage(data);
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  return (
    <div>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      <div className="w-full px-5 h-9 text-white text-xs font-medium bg-btnBg flex justify-between items-center">
        <div className="flex items-center justify-center">
          <img src="assets/img/back.png" className="w-5 cursor-pointer" onClick={() => handleClose()} alt="" />
          <span className="text-sm ml-4 font-semibold">
            {assetId} ({deviceId}) Trace Report
          </span>
        </div>
        {/* <div className="flex items-center justify-end">
          <img src="assets/img/Battery.png" className="w-4 mx-2" alt="" />
          <span>872mv</span>
          <img src="assets/img/Antenna.png" className="w-4 mx-2" alt="" />
          <span>-872dbm</span>
        </div> */}
      </div>
      {!isLoading ? (
        <div className="w-full flex my-6">
          <div className="w-7/12">
            {traceData && (
              <>
                <div className=" border-b text-md font-light">
                  <div className="flex items-start justify-start w-full mx-6 mb-4">
                    <div className="mr-6 w-1/6">
                      <p className="text-md font-semibold text-role text-right">
                        {' '}
                        {traceData !== undefined ? traceData.deviceInfo.createdAt.substring(0, 10) : '---'}
                      </p>
                      <p className="text-timeColor font-normal mt-0.5 text-xs text-right">
                        {traceData !== undefined
                          ? parseInt(traceData.deviceInfo.createdAt.substring(11, 13), 10) > 12
                            ? `${traceData.deviceInfo.createdAt.substring(11, 19)} PM`
                            : `${traceData.deviceInfo.createdAt.substring(11, 19)} AM`
                          : '---'}
                      </p>
                    </div>
                    <div className="border-2 mt-1 flex items-center justify-center border-green-500 w-6 h-6 rounded-full mr-6">
                      <div className="w-2 h-2 bg-green-500 rounded-full " />
                    </div>
                    <p className="w-7/12 font-semibold text-role text-sm mt-1"> Asset Created</p>
                  </div>
                  <div className="flex items-start justify-start w-full mx-6 mb-4">
                    <div className="mr-6 w-1/6">
                      <p className="text-md font-semibold text-role text-right">
                        {' '}
                        {traceData !== undefined ? traceData.deviceInfo.lastReportedAt.substring(0, 10) : '---'}
                      </p>
                      <p className="text-timeColor font-normal mt-0.5 text-xs text-right">
                        {traceData !== undefined
                          ? parseInt(traceData.deviceInfo.lastReportedAt.substring(11, 13), 10) > 12
                            ? `${traceData.deviceInfo.lastReportedAt.substring(11, 19)} PM`
                            : `${traceData.deviceInfo.lastReportedAt.substring(11, 19)} AM`
                          : '---'}
                      </p>
                    </div>
                    <div className="border-2 mt-1 flex items-center justify-center border-green-500 w-6 h-6 rounded-full mr-6">
                      <div className="w-2 h-2 bg-green-500 rounded-full" />
                    </div>
                    <p className="w-7/12 font-semibold text-role text-sm mt-1"> Asset Last Reported</p>
                  </div>
                </div>
                <div className="hideScroll" style={{ overflowY: 'scroll', height: '64vh' }}>
                  {traceData.data.map((x, idx) => (
                    <div className="flex items-start justify-start w-full mx-6 mt-4">
                      <div className="mr-6 w-1/6">
                        <p className="text-base font-semibold text-right text-role"> {x.time.substring(0, 10)}</p>
                        <p className="text-timeColor font-normal mt-0.5 text-xs text-right">
                          {parseInt(x.time.substring(11, 13), 10) > 12
                            ? `${x.time.substring(11, 19)} PM`
                            : `${x.time.substring(11, 19)} AM`}
                        </p>
                      </div>
                      <div
                        className={`border-2 mt-1 flex items-center justify-center border-circle w-6 h-6 rounded-full relative ${
                          traceData.data.length - 1 !== idx && 'test1'
                        } mr-6 bg-white`}
                      >
                        <div className="w-2 h-2 bg-circle rounded-full" />
                      </div>
                      <div className="w-7/12">
                        <p className="font-semibold text-role text-sm mt-1">{traceData.location[idx].loc[0].formattedAddress}</p>
                        <p className="text-timeColor font-normal mt-0.5 text-xs">
                          {x.BLE_GW_ID
                            ? `Reported By: ${x.BLE_GW_ID}`
                            : null}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                {/* <div className="mr-6"> */}
              </>
            )}
          </div>
          <div className="w-5/12 h-fill mx-8 ">
            {traceData !== undefined && (
              <MapComponent selectedPage="traceability" coordinates={coordinates.reverse()} center={center} polyline />
            )}
            {/* {traceData === undefined && <MapComponent selectedPage="traceability" center={center} polyline />} */}
            {/* <GoogleMapReact
            key={coordinates}
            bootstrapURLKeys={{ key: 'AIzaSyDVsc9GqAbD6BF7vKPaLTNgtFFksrxj0Yw' }}
            options={getMapOptions}
            defaultZoom={11}
            center={center}
            onGoogleApiLoaded={({ map, maps }) => handlegoogleApi(map, maps, coordinates)}
            yesIWantToUseGoogleMapApiInternals
          /> */}
          </div>
        </div>
      ) : (
        <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
      )}
    </div>
  );
}

export default Traceability;
